
import { Component, Vue, Prop, computed } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class AssessmentTemplateCard extends Vue {
  @Prop({ required: true })readonly id: number
  @Prop({ required: true })readonly creatorId: number
  @Prop({ required: true })readonly title: string
  @Prop({ required: true })readonly description: string
  @Prop({ required: true })readonly keywords: string
  @Prop({ required: true })readonly type: string
  @Prop({ required: true })readonly prompt: string
  @Prop({ required: true })readonly sampleQuote: string
  @Prop({ required: true })readonly sampleOutput: string
  @Prop({ required: true })readonly category: string
  @Prop({ required: true })readonly active: boolean
  @Prop({ required: true })readonly hasViewBtn: boolean

  data () {
    return {
    }
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }

  viewTaskTemplate () {
    this.$emit('viewClick', this.id)
  }
}
